import React, { useEffect, useState } from 'react'
import { Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Typography, TextField, Box } from '@mui/material'

const apiFetch = (url, options = {}) => {
  url = 'https://api.ideakart.in' + url
  return fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'supersecrettoken_nolongerworking_244',
      ...options.headers,
    },
    ...options,
  })
}

const AdminDashboard = () => {
  const [activitySummary, setActivitySummary] = useState([])
  const [paymentSummary, setPaymentSummary] = useState([])
  const [scrapers, setScrapers] = useState([])
  const [tokens, setTokens] = useState({})
  const [newEmail, setNewEmail] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchActivitySummary()
    fetchPaymentSummary()
    fetchScrapers()
  }, [])

  const fetchActivitySummary = async () => {
    const res = await apiFetch('/activity-summary')
    const data = await res.json()
    setActivitySummary(data)
  }

  const fetchPaymentSummary = async () => {
    const res = await apiFetch('/payment-summary')
    const data = await res.json()
    setPaymentSummary(data)
  }

  const fetchScrapers = async () => {
    const res = await apiFetch('/all-scrapers')
    const data = await res.json()
    setScrapers(data)
    const t = {}
    data.forEach(s => t[s.email] = s.token)
    setTokens(t)
  }

  const assignProfiles = async (scraper, date) => {
    setLoading(true)
    await apiFetch('/assign-profiles', {
      method: 'POST',
      body: JSON.stringify({ scraper_email: scraper, date }),
    })
    fetchActivitySummary()
    setLoading(false)
  }

  const createUser = async () => {
    const res = await apiFetch('/create-user', {
      method: 'POST',
      body: JSON.stringify({ email: newEmail }),
    })
    const data = await res.json()
    setTokens((prev) => ({ ...prev, [newEmail]: data.token }))
    setScrapers((prev) => [...new Set([...prev, { email: newEmail, token: data.token }])])
    setNewEmail('')
  }

  const today = new Date()
  const upcomingDays = Array.from({ length: 6 }, (_, i) => {
    const d = new Date(today)
    d.setDate(d.getDate() + i + 1)
    return d.toISOString().split('T')[0]
  })

  return (
    <Container>
      <Typography variant="h4" sx={{ mb: 3 }}>Scraped Summary</Typography>
      <TableContainer component={Paper} sx={{ mb: 5 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Email</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Scraped</TableCell>
              <TableCell>Scraped IDs</TableCell>
              <TableCell>Scraped Vanity Names</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {activitySummary.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell>{row.email}</TableCell>
                <TableCell>{row.date}</TableCell>
                <TableCell>{row.linked_creator_ids.length}</TableCell>
                <TableCell>{row.linked_creator_ids.join(', ')}</TableCell>
                <TableCell>{row.linked_creator_vanity_names.join(', ')}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="h4" sx={{ mb: 3 }}>Payment Status</Typography>
      <TableContainer component={Paper} sx={{ mb: 5 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Email</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Paid</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paymentSummary.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell>{row.email}</TableCell>
                <TableCell>{row.date}</TableCell>
                <TableCell>{row.paid ? '✅' : '❌'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="h4" sx={{ mb: 3 }}>Assign Profiles</Typography>
      <TableContainer component={Paper} sx={{ mb: 5 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Scraper</TableCell>
              {upcomingDays.map((d, i) => (
                <TableCell key={i}>{d}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {scrapers.map((scraper, i) => (
              <TableRow key={i}>
                <TableCell>{scraper.email || scraper}</TableCell>
                {upcomingDays.map((d, j) => (
                  <TableCell key={j}>
                    <Button
                      size="small"
                      variant="contained"
                      disabled={loading}
                      onClick={() => assignProfiles(scraper.email || scraper, d)}
                    >
                      Assign
                    </Button>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="h4" sx={{ mb: 3 }}>Create New Scraper</Typography>
      <Box display="flex" alignItems="center" gap={2} mb={4}>
        <TextField
          size="small"
          label="Scraper Email"
          value={newEmail}
          onChange={(e) => setNewEmail(e.target.value)}
        />
        <Button variant="contained" onClick={createUser}>Create</Button>
      </Box>

      <Typography variant="h5" sx={{ mb: 1 }}>Scraper Tokens</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Email</TableCell>
              <TableCell>Token</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(tokens).map(([email, token]) => (
              <TableRow key={email}>
                <TableCell>{email}</TableCell>
                <TableCell sx={{ wordBreak: 'break-all' }}>{token}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  )
}

export default AdminDashboard
